import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  page: {
    backgroundColor: "#ffffff",
    fontFamily: "Helvetica",
    fontSize: "12px",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    color: "#000",
    position: "relative",
  },
  section: {
    margin: "12px 50px",
    fontFamily: "Helvetica",
  },
  text: {
    color: "#666",
    fontSize: "11px",
  },
  title: {
    fontSize: "16px",
    textAlign: "center",
  },
  header: {
    width: "100%",
    backgroundColor: "#fff",
    heigth: 120,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    marginBottom: 10,
  },
  image: {
    width: 100,
    marginTop: 10,
  },
  addressContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    margin: 0,
    padding: 0,
    marginTop: 10,
  },
  imageWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    margin: 0,
    padding: 0,
  },
  dateWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    marginTop: "10px",
    marginBottom: "10px",
    gap: "20px",
  },
  dateContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    marginRight: "50px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    textAlign: "justify",
    flex: 1,
  },
  bodyText: {
    fontSize: "11px",
    marginBottom: "8px",
  },
  bodyTextBold: {
    fontSize: "11px",
    marginBottom: "8px",
    fontWeight: "bold",
    textDecoration: "underline",
  },
  dateTitle: {
    fontSize: "9px",
    fontFamily: "Helvetica-Bold",
  },
  dateText: {
    fontSize: "9px",
    marginBottom: "5px",
  },
  list: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
  },
  itemList: {
    fontSize: "10px",
    marginBottom: "4px",
  },
  smallText: {
    fontSize: "11px",
  },
  listTitle: {
    fontFamily: "Helvetica-Bold",
    fontSize: "11px",
  },
  centralizeView: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
  },

  // TABLE
  table: {
    display: "flex",
    flexDirection: "column",
    width: "400px",
    marginBottom: 4,
    fontSize: "11px",
  },
  row: {
    display: "flex",
    flexDirection: "row",
  },
  cell: {
    padding: 5,
  },
  tableTitle: {
    width: 400,
    textAlign: "left",
    paddingBottom: 6,
  },
  rightCell: {
    width: 100,
    textAlign: "right",
  },
  rightCellBorder: { borderLeft: "1px solid #000" },
  leftCell: {
    width: 300,
    textAlign: "left",
  },
  grayBackground: {
    backgroundColor: "#c1e4f5",
  },
  blueBackground: {
    backgroundColor: "#C8DAF8",
  },
  greyBackground: {
    backgroundColor: "#F3F3F3",
  },
  lightGreyBackground: {
    backgroundColor: "#F6F8FE",
  },
  headerRow: {
    fontFamily: "Helvetica-Bold",
    padding: 5,
    paddingBottom: 0,
    borderBottom: "1px solid #505050",
  },
  // END TABLE
  // NO DISCOUNT PDF BREAKDOWN
  payerContainer: {
    display: "flex",
    flexDirection: "column",
    padding: 5,
    backgroundColor: "#F6F8FE",
    border: "1px solid #E2E2E4",
    borderRadius: 5,
    color: "#344054",
    fontSize: "11px",
  },
  payerTitleBold: {
    fontSize: "11px",
    color: "#17143f",
    fontFamily: "Helvetica-Bold",
    marginBottom: "8px",
    display: "flex",
    gap: "10px",
  },
});
